// import React from 'react';
// import KardexHistAdmision from '../kardex/KardexHistAdmision';

// export default function JefaturaHistorialAcademico({ readOnly = false }) {
//     return (
//         <div className="p-6">
//             {/* Header */}
//             <div className="mb-6">
//                 <h1 className="text-xl font-bold text-gray-800">{!readOnly ? 'Jefatura de Carrera' : 'Dirección Académica'} &gt; Consultas &gt; Historial Académico</h1>
//             </div>

//             {/* Content */}
//             <div className="bg-white rounded-lg shadow overflow-hidden">
//                 <KardexHistAdmision readOnly={readOnly} />
//             </div>
//         </div>
//     );
// }

import React from 'react';
import KardexHistAdmision from '../kardex/KardexHistAdmision';

export default function JefaturaHistorialAcademico({ readOnly = false }) {
    return (
        <div>
            {/* Header de Jefatura / Dirección */}
            <div className="px-6 pt-6 ">
                <h1 className="text-xl font-bold text-gray-800">
                    {!readOnly ? 'Jefatura de Carrera' : 'Dirección Académica'} &gt; Consultas &gt; Historial Académico
                </h1>
            </div>

            {/* Pasamos hideHeader={true} para evitar que el hijo renderice otro título o margen superior duplicado */}
            <div>
                <KardexHistAdmision readOnly={readOnly} hideHeader={true} />
            </div>
        </div>
    );
}